import { trackClickEvent } from '../../services/tracking/pulseEvents.js';

interface TrackNavigationClickParams {
  label: string;
  link?: string;
  id?: string | number;
  type?: string;
}

export const trackNavigationClick = ({
  label,
  link,
  id,
  type = 'Category',
}: TrackNavigationClickParams) => {
  const parent = {
    elementType: 'Navigation',
    name: 'Navigation',
  };

  const object = {
    id: id || label,
    elementType: 'MenuItem',
    url: link,
    title: label,
  };

  const target = {
    id,
    title: label,
    url: link,
    type,
  };

  trackClickEvent(parent, object, target);
};
